import { useEnv } from '@/lib/env'
import { useFirestoreSnapshot } from '@/lib/index'
import * as React from 'react'
import { Renderer } from './internal'
import * as firestore from 'firebase/firestore'

interface Props {}

function Archive(_props: Props) {
  const { db } = useEnv()

  const query = firestore.query(firestore.collection(db, 'popularVotes'), firestore.orderBy('day', 'desc'))
  const popularVotesSnapshot = useFirestoreSnapshot(query)

  if (popularVotesSnapshot) {
    // All but the first popular vote are considered archived.
    const popularVotes = popularVotesSnapshot.docs
      .slice(1)
      .map((doc) => ({ id: doc.id, date: (doc.data() || {}).day.toDate() }))

    return <Renderer popularVotes={popularVotes} />
  } else {
    return null
  }
}

export default Archive
